import { CrudStoreItemPartner360 } from 'legacy/lut/classes/models/partner360/CrudStoreItemPartner360'
import { IJBPGroupMembersString } from 'legacy/lut/classes/models/partner360/IPartnerGroup'

import { Logic, Operator } from 'core-components/types'
import { CrudStore } from 'core/types/crudStore'

export const fetchGroupMembersString = async (groupId: number): Promise<string> => {
  const crud = CrudStore.get<IJBPGroupMembersString>(
    CrudStoreItemPartner360.JBPGroupMembersString,
    'fetchGroupMembersString'
  )
  crud.setDefaultFilter({
    logic: Logic.AND,
    filters: [
      {
        field: 'GroupId',
        operator: Operator.EQUAL,
        value: groupId,
      },
    ],
  })

  const res = await crud.fetch({ force: true })
  return res?.items?.[0]?.PartnerIds || ''
}
